export default {
  finish: 'Finish',
  ok: 'Ok',
  'calendar-tutorial-one': {
    'step-one-header': 'Client Search',
    'step-one-content': 'Search for a Client to quickly access their information and schedule their next appointment.',
    'step-two-header': 'Adjust Calendar view',
    'step-two-content': 'View your Calendar by day, week, or month. You can also use the Filters to select specific Staff Members or Resources.',
    'step-three-header': 'Add an appointment',
    'step-three-content': 'Click here to add a new appointment to your Calendar. You can also add time reservation to prevent your clients from booking you while you\'re busy.',
  },
  'calendar-tutorial-two': {
    'step-one-header': 'Fill in the details',
    'step-one-content': 'Select your Client and then add all of your appointment details such as the Service, Staff Member, and any notes.',
  },
  'checkout-tutorial-one': {
    'step-one-header': 'Streamline the Checkout process',
    'step-one-content': 'Booksy\'s integrated checkout experience makes it quick and easy to settle up with your clients.',
    'step-two-header': 'Who\'s buying?',
    'step-two-content': 'First select the Client that you would like to Checkout. If you\'d like you can also leave this blank for walk-in sales.',
    'step-three-header': 'Make your selections',
    'step-three-content': 'Choose a category to find the items you want to add to the cart. Your most popular items will be found under Quick Sale.',
    'step-four-header': 'Add to the cart',
    'step-four-content': 'Click on specific items to add them to the cart. You can add as many as you need to.',
    'step-four-no-register-content': 'After opening register, click on specific items to add them to the cart. You can add as many as you need to.',
  },
  'checkout-tutorial-two': {
    'step-one-header': 'Preview the cart',
    'step-one-content': 'Everything you\'ve added to the cart will be visible here. You can click on individual items to make edits.',
    'step-two-header': 'Using discounts and promo codes',
    'step-two-content': 'Click here to add a discount or apply a promo code to the entire cart. If you need to discount a single item, please click on that item instead.',
    'step-three-header': 'Continue to tip and payment',
    'step-three-content': 'Once your cart is final click "Continue". On the following screens you\'ll be able to add tip and select your payment method(s).',
  },
  'profile-tutorial': {
    'step-one-content': 'Want to see what your customers are seeing? Preview your profile to see how your digital storefront is looking.',
    'step-two-content': 'Make it easy for customers to book with you. Share your Booksy Profile Link via social media, in e-mail, and on your website.',
    'step-three-content': 'Update your Cover Photo to give your customers a sneak peak of your space and establish your brand.',
    'step-three-no-cover-content': 'Add a Cover Photo to give your customers a sneak peak of your space and establish your brand.',
  },
  'commission-tutorial-one': {
    'step-one-header': 'Staff Member Selection',
    'step-one-content': 'Using this dropdown you have the option to apply Commissions to All Staff Members or build them out for each individual Staff Member.',
    'step-two-header': 'Category & Service Level Commissions',
    'step-two-content': 'You can apply Commission values to entire Service Categories and/or make adjustments for specific Services.',
    'step-three-header': 'Editing Commissions',
    'step-three-content': 'Click any of your existing Commission values to edit it.',
  },
  'commission-tutorial-two': {
    'step-one-header': 'Choose Commission type',
    'step-one-content': 'Choose whether you would like your Commission to be a % or fixed amount and then assign a value.',
    'step-two-header': 'Save your changes',
    'step-two-content': 'Click "Save" to apply any changes that you\'ve made.',
  },
  'shifts-tutorial': {
    'step-one-header': 'Shifts',
    'step-one-content': 'Simplify Staff scheduling. In a single view you can create, modify, and replicate your weekly schedules so everyone knows exactly where they\'re supposed to be.',
    'step-two-header': 'Adjust views',
    'step-two-content': 'View your Shifts for a particular day or for an entire week. You can also filter by Staff member or Resource.',
    'step-three-header': 'Edit Business Hours',
    'step-three-content': 'By default Staff Shifts are set to match your Business Hours. Any changes to Business Hours could also impact Shifts.',
    'step-four-header': 'Edit Single Day Business Hours',
    'step-four-content': 'Edit Business Hours for a single day. This will impact any Shifts on this day that are assigned to default hours.',
    'step-five-header': 'Modify Default Shifts',
    'step-five-content': 'Click the pencil icon to edit the default Shifts for this Staff Member. Changes will apply to all future dates.',
    'step-six-header': 'Edit a single Shift',
    'step-six-content': 'Click on any Shift to edit it. Changes will only impact the selected Staff Member for that particular day.',
    'step-seven-header': 'Duplicate and print Shifts',
    'step-seven-content': 'Reduce the admin work. Copy Shifts from a particular day and apply them to any date range in the future.<br><br>Here you can also print your Shifts to have on hand.',
    'step-seven-header-no-print': 'Duplicate Shifts',
    'step-seven-content-no-print': 'Reduce the admin work. Copy Shifts from a particular day and apply them to any date range in the future.',
    'step-eight-header': 'Adding Time Off',
    'step-eight-content': 'Click here to add time off for your Staff Members.',
  },
  'message-blasts': {
    'preview-tutorial': {
      'step-one-header': 'Get started!',
      'step-one-content': 'Tap "Activate Campaign" to automatically send this message to your clients according to the scheduling guidelines in summary.',
      'step-two-header': 'Scroll down to see all versions of this campaign.',
      'step-two-content': 'SMS and push notifications are text only and have restrictions to the number of characters in the message. Emails don\'t have character restrictions and can include and image.',
      'step-three-header': 'Editing message template',
      'step-three-content': 'Tap "Edit" to customize the message. Try changing the image or editing the text to make it look and sound like you.',
    },
    'edit-tutorial': {
      'step-one-header': 'You can send this message 3 ways',
      'step-one-content': 'If you want to send a message with just text, send an SMS or a push notification. If you want to include an image, send an email.',
      'step-two-header': 'Delivery timeline',
      'step-two-content': 'Choose when to send your message. Consider which day of the week and which time of day would be best to reach your clients.',
      'step-three-header': 'Delivery method',
      'step-three-content': 'Choose how you want your clients to receive this message, or let us choose. We always go for the method that is most likely ot reach your client and get them to take action.',
      'step-four-header': 'Character limits for email, SMS and push notification',
      'step-four-content': 'Keep SMS and push notifications short. While you technically have a 304 character limit for SMS and push notifications, our data actually says keeping it to around 140 characters yields the best results.<br><br>No character limit for email, so you can write the next great novel if that\'s what you want to do.',
      'step-five-header': 'Use the editing tools',
      'step-five-content': 'Make as many edits to the template as you\'d like. If you need to completely start over, just Reset and it will go back to original template.<br><br>Think you\'ve got your message perfected? You can send yourself a test version of the message, or see a preview.',
    },
  },
  'deposit-toggle-tile-tutorial': {
    'step-one-header': 'Easily add a deposit',
    'step-one-content': 'Secure the appointment by entering your client’s card details to collect a deposit. It’s a simple way to protect your business from no-shows.',
  },
  'first-appointment-tutorial': {
    'step-one-header': 'Who’s coming?',
    'step-one-content': 'You’ll be able to select an existing client or add a new client.',
    'step-two-header': 'Quick test drive!',
    'step-two-content': 'You can add your own details to quickly test this feature.',
    'step-three-header': 'What’s the appointment for?',
    'step-three-content': 'Choose your service and make any other changes you want before saving.',
    'step-four-header': 'Nice work!',
    'step-four-content': 'Your appointment is saved. You can select the appointment if you need to edit or delete it.',
  },
  'bgc-walkthrough-tutorial': {
    'step-one-header': 'Booksy Gift Card icon',
    'step-one-content': 'This icon indicates that the client used a Booksy Gift Card when booking. Click the appointment to see the details.',
    'step-two-header': 'Check out the appointment to get paid',
    'step-two-content': 'Here you\'ll see the amount paid with the Booksy Gift Card. Once the appointment is finished, use the Checkout button and complete checkout. The funds will then be added to your balance.',
  },
}
